import { render, staticRenderFns } from "./logiststList.vue?vue&type=template&id=34a920c2&scoped=true&"
import script from "./logiststList.vue?vue&type=script&lang=js&"
export * from "./logiststList.vue?vue&type=script&lang=js&"
import style0 from "./logiststList.vue?vue&type=style&index=0&id=34a920c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a920c2",
  null
  
)

export default component.exports